<template lang="pug">
  .password-change
    p.error(v-if="passwordError") {{ passwordError }}
    form(v-on:keyup="checkSubmit")
      label(for="cart-old") Old Password
      input#cart-old(v-model="oldPassword" placeholder="Enter your old password" type="password")
      label(for="cart-password") New Password
      input#cart-password(v-model="newPassword" placeholder="Enter your new password" type="password")
      label(for="cart-confirm-password") Confirm New Password
      input#cart-confirm-password(v-model="confirmNewPassword" placeholder="Please confirm your new password" type="password")
      button(:disabled="saving" type="button" @click="verifyPassword") {{ saving ? "Saving..." : "Change Password" }} 
  
</template>

<script>
import connect from "../scripts/database.js";

export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      passwordError: "",
      saving: false
    };
  },
  computed: {
    passwordLength() {
      if (this.newPassword) {
        if (this.newPassword.length >= 6) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    verifyPassword() {
      if (!this.passwordLength) {
        this.passwordError = "Password length must be at least 6 characters";
      } else if (this.newPassword != this.confirmNewPassword) {
        this.passwordError = "Passwords do not match";
      } else {
        this.saveNewPassword();
      }
    },
    saveNewPassword() {
      this.passwordError = "";
      this.saving = true;

      var user = connect.auth.currentUser;

      var credentials = connect.emailAuth.credential(
        user.email,
        this.oldPassword
      );

      user
        .reauthenticateWithCredential(credentials)
        .then(data => {
          user
            .updatePassword(this.newPassword)
            .then(() => {
              console.log("password updated");
              this.saving = false;
              this.$root.confirmation.msg = "Password Changed!";
              this.$root.confirmation.returnState = "account";
              this.$root.confirmation.returnMsg = "View Account";
              this.$root.confirmation.open = true;
            })
            .catch(function(err) {
              this.passwordError = err.message;
              this.saving = false;
              console.error(err.message);
            });
        })
        .catch(err => {
          this.passwordError = "Old password is invalid";
          this.saving = false;
          console.log(err.message);
        });
    },
    checkSubmit(e) {
      if (e && e.keyCode == 13) {
        this.verifyPassword();
      }
    }
  },
  created() {}
};
</script>

<style lang="scss">
@import "../assets/styles/reset.scss";
@import "../assets/styles/variables.scss";

#app .password-change {
  form {
    padding: 0 24px 24px;
    label {
      display: block;
      font-size: 0.9em;
      margin: 0.8em 0;
    }

    input {
      border: 1px $border_gray solid;
      border-radius: 7px;
      padding: 1em 0.5em;
      position: relative;
      width: 100%;
    }
  }
  .error {
    padding: 24px;
  }
}
</style>
